<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar"
      top="true"
      left="true"
      :timeout="5000"
      color="success"
    >
      <v-span class="mx-2 white--text"> {{ snackbar_message }}</v-span>
      <v-btn @click="snackbar = false" class="ml-16" text>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-content>
      <div class="staticHero">
        <v-img src="../assets/images/contact.png">
          <v-row align="end" class="lightbox white--text pa-2 fill-height">
            <v-col>
              <v-container>
                <div class="headline">Contact Me</div>
              </v-container>
            </v-col>
          </v-row>
        </v-img>
      </div>

      <div class="googlemap">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d154755.39199695105!2d-9.134998273580516!3d38.64739239098656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2spt!4v1664031535933!5m2!1sen!2spt"
          width="100%"
          height="450"
          style="border:0;"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
      <div>
        <v-container>
          <h1 class="white--text">
            <strong> Leave me a Message here:</strong>
          </h1>
          <v-form ref="form" v-model="valid" @submit.prevent="sendEmail">
            <v-text-field
              prepend-icon="person"
              dark
              v-model="name"
              placeholder="Your Name."
              name="name"
              :counter="10"
              :rules="nameRules"
              label="Name"
              required
            ></v-text-field>
            <v-text-field
              prepend-icon="email"
              dark
              v-model="email"
              placeholder="Youe Email."
              name="email"
              :rules="emailRules"
              label="E-mail"
              required
            ></v-text-field>
            <v-textarea
              prepend-icon="message"
              dark
              v-model="message"
              placeholder="Feedback Message."
              name="message"
              :rules="messageRules"
              label="Message"
              required
            ></v-textarea>
            <v-btn
              :disabled="!valid"
              color="#1216e0"
              :loading="loading"
              class="mr-4 white--text"
              type="submit"
              ><strong>Submit</strong>
            </v-btn>
            <v-btn color="error" class="mr-4" @click="reset"
              ><strong>Reset</strong>
            </v-btn>
          </v-form>
        </v-container>
      </div>
    </v-content>
  </div>
</template>

<script>
import emailjs from "emailjs-com";
export default {
  name: "Contact",
  data: () => ({
    valid: true,
    name: "",
    loading: false,
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    message: "",
    messageRules: [
      (v) => !!v || "Message is required",
      (v) => (v && v.length >= 10) || "Message must be more than 10 characters",
    ],
    snackbar: false,
    snackbar_message: "",
  }),

  methods: {
    reset() {
      (this.name = ""), (this.message = ""), (this.email = "");
    },

    sendEmail(e) {
      if (this.$refs.form.validate()) {
        this.loading = true;
        console.log(e.target);
        emailjs
          .sendForm(
            "yareda",
            "template_y0zhtpb",
            e.target,
            "user_R2x03vVR1f0jOnj5E7j4X"
          )
          .then(
            (result) => {
              this.loading = false;
              console.log("SUCCESS!", result.status, result.text, result);
              this.snackbar_message = "Well Recieved And Thank You.";
              this.snackbar = true;
            },
            (error) => {
              this.loading = false;
              this.snackbar_message = error;
              this.snackbar = true;
            }
          );

        this.reset();
      }
    },
  },
};
</script>
